<template>
  <div :id="'descreteSelect' + '-' + randomId">
    <v-menu
      v-model="isOpened"
      v-bind="{
        offsetY: true,
        contentClass: 'mt-2',
        attach: `#descreteSelect-${randomId}`,
        ...menuProps,
      }"
    >
      <template v-slot:activator="{on, attrs}">
        <v-btn
          class="zoox-component zoox-descrete-select"
          text
          :style="{
            'margin-top': xSmall ? '4px' : null,
            'min-width': xSmall ? '28px' : null,
          }"
          :small="!xSmall"
          :x-small="xSmall"
          :disabled="disabled"
          v-bind="attrs"
          v-on="on"
        >
          <!--@slot Slot para customização do item selecionado -->
          <slot name="selected">
            <span class="zoox-descrete-select-text">
              {{ currentValueText }}
            </span>
          </slot>
          <v-icon right dark> {{ openIcon }} </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-virtual-scroll
          bench="10"
          max-height="300"
          item-height="40"
          min-width="105"
          :items="items"
          :width="itemWidth"
        >
          <template v-slot:default="{item}">
            <v-list-item :key="item.value" @click="onSelectOption(item)">
              <!--@slot Slot para customização dos itens do select 
                  @binding {object} option Objeto referente aos itens do select
            -->
              <slot name="option" :option="item">
                {{ item.text }}
              </slot>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
/**
 * @displayName Descrete Select
 */
export default {
  name: 'ZDescreteSelect',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /**
     * Select label
     */
    label: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Select items
     *
     * @typedef Object {text:string,value:any}
     */
    items: {
      type: Array,
      required: true,
    },
    /**
     * Selected value
     *
     * @modelName value
     */
    value: {
      type: [String, Number],
      required: true,
    },
    /**
     * Flag para desabilitar o select
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Tamanho do item do select
     */
    itemWidth: {
      type: Number,
      required: false,
    },
    /**
     * Flag para esconder o ícone de abrir o select
     */
    hideIcon: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para adicionar o ícone de abrir o select
     */
    openIcon: {
      type: String,
      default: '$keyboard_arrow_down_rounded',
    },
    xSmall: {
      type: Boolean,
      default: false,
    },
    /**
     * Props que serão aplicadas ao `v-menu`
     */
    menuProps: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isOpened: false,
      randomId: '',
    }
  },

  computed: {
    currentValueText() {
      const {text} = this.items.find((item) => item.value === this.value) || {}

      return text || this.label || ''
    },
  },

  created() {
    this.randomId = this.generateRandomId()
  },

  methods: {
    /**
     * @public
     */
    open() {
      this.isOpened = true
    },
    /**
     * @public
     */
    close() {
      this.isOpened = false
    },
    onSelectOption(option) {
      /**
       * Emitido quando há alteração no valor
       *
       * @property {String} option - Valor da opção selecionada
       */
      this.$emit('change', option.value)
    },

    generateRandomId() {
      return String(
        Date.now().toString(32) + Math.random().toString(16)
      ).replace(/\./g, '')
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-descrete-select-text {
  font-family: 'Roboto', sans-serif;
  text-transform: initial;
  font-size: 0.875rem;
  font-weight: 400;
}

.arrow-menu {
  transform: translateX(-50%);
  position: absolute;
  border-bottom: solid 8px var(--white) !important;
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  top: 28px;
  left: 50%;
  height: 0px;
  width: 0px;
  z-index: 9;
}

.v-list {
  padding: 0 !important;
}
</style>
